import React from 'react'

const ArrowRightIcon = (props) => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="9.732" height="19.295" viewBox="0 0 9.732 19.295"><path d="M3.561 0a1 1 0 0 0-.961.741l-2.566 9.559a1 1 0 1 0 1.932.518l2.562-9.559a1 1 0 0 0-.967-1.259z" transform="translate(5.781 7) rotate(30)" fill={props.fill} /><path d="M1 0a1 1 0 0 0-.966 1.259l2.566 9.562a1 1 0 1 0 1.928-.521l-2.562-9.559a1 1 0 0 0-.966-.741z" transform="translate(0 2.281) rotate(-30)" fill={props.fill} /></svg>
	)
}

export default ArrowRightIcon